module.exports = __webpack_public_path__ + "static/media/thaihouse.e7974996.webp";